import {ColumnDef, createColumnHelper} from '@tanstack/react-table'
import {FC, useEffect, useMemo, useState} from 'react'
import useAxiosPrivate from '../../../../libs/useAxiosPrivate'
import DataTable from '../../../../../ui-kit/DataTable/DataTable'
import {Link} from 'react-router-dom'
import { deleteTariffByTypeAndID } from '../core/_requests'
import {showSwal} from '../../../../../ui-kit'

interface DataRow {
  id?: number
  rep: string
  par: string
  year: number
  hs: string
  hs_description: string
  hs_version: string
  r_max: string
  r_avg: number
}

const confirmDialog = (title: string) => {
  return showSwal({
    title,
    icon: 'question',
    showCloseButton: true,
    showCancelButton: true,
    confirmButtonText: 'Yes',
    cancelButtonText: 'No',
  })
}

type ListPrefTariffTableProps = {
  data: Array<DataRow>
  isLoading: boolean
  onDeleteSuccess?: () => void
}
const columnHelper = createColumnHelper<DataRow>()

const ListPrefTariffTable: FC<ListPrefTariffTableProps> = ({
  data = [],
  isLoading,
  onDeleteSuccess,
}) => {
  const [dataTable, setDataTable] = useState<DataRow[]>([])

  useEffect(() => {
    if (data.length > 0) {
      setDataTable(data)
    }
  }, [data])

  const columns: ColumnDef<DataRow, any>[] = useMemo(
    () => [
      columnHelper.accessor('hs', {
        header: 'Commodity',
        cell: (info) => <span className='badge text-white bg-dark'>{info.getValue()}</span>,
        meta: {
          headerClass: 'w-100px text-center',
          cellClass: 'text-center',
        },
        enableSorting: true,
        enableGlobalFilter: true,
      }),
      columnHelper.accessor('hs_description', {
        header: 'Description',
        cell: (info) => info.getValue(),
        meta: {
          headerClass: '',
          cellClass: '',
        },
        enableSorting: true,
        enableGlobalFilter: true,
      }),
      columnHelper.accessor('year', {
        header: 'Year',
        cell: (info) => info.getValue(),
        meta: {
          headerClass: '',
          cellClass: '',
        },
        enableSorting: true,
        enableGlobalFilter: true,
      }),
      columnHelper.accessor('r_avg', {
        header: 'Tariff',
        cell: (info) => `${Math.round(info.getValue())}%`,
        meta: {
          cellClass: 'text-end',
          headerClass: 'font-bold',
        },
        enableSorting: true,
        enableGlobalFilter: true,
      }),
      columnHelper.accessor('id', {
        header: 'Actions',
        cell: (info) => (
          <div className='d-flex gap-3 justify-content-center'>
            <Link to={`/tariff/${'pref'}/${encodeURIComponent(info.getValue() || '')}`}>
              <span className='fa fa-eye'></span>
            </Link>
            <Link to='#' className='link-danger' onClick={() => handleDelete(info.getValue())}>
              <span className='fa fa-trash'></span>
            </Link>
          </div>
        ),
        meta: {
          cellClass: 'text-center',
          headerClass: 'font-bold',
        },
        enableSorting: false,
        enableGlobalFilter: false,
      }),
    ],
    []
  )

  const axiosPrivate = useAxiosPrivate()

  const handleDelete = (id: any) => {
      confirmDialog('Are you sure you want to delete this Preferential Tariff?').then((result) => {
        if (!result.isConfirmed) return
  
        deleteTariffByTypeAndID(axiosPrivate, 'pref', id).then((res) => {
          if (res.status === 200) {
            showSwal({
              title: 'Preferential Tariff deleted',
              icon: 'success',
              confirmButtonText: 'OK',
            }).then(() => setDataTable((prev) => prev.filter((row) => row.id !== id)))
          }
        })
      })
    }

  return (
    <>
      <DataTable<DataRow>
        data={dataTable}
        columns={columns}
        isLoading={isLoading}
        enablePagination={true}
        enableSorting={true}
        enableGlobalFilter={true}
        globalFilterPlaceholder=''
        defaultPageSize={20}
        pageSizes={[5, 10, 20, 50, 100]}
        className='my-custom-table-wrapper'
        initialSortBy={{id: 'hs', desc: false}}
      />
    </>
  )
}

export default ListPrefTariffTable
